import {useEffect, useRef} from "react";
import type {MapFacility} from "../layers/useFacilitiesLayer";
import {renderFacilitiyString, renderInfoWindow} from "../utils";
import {MarkerClusterer} from "@googlemaps/markerclusterer";

const useFacilitiesMarker = (
    map: google.maps.Map | undefined,
    facilities: MapFacility[],
    siteTypes: string[],
    clientID?: string
) => {
  const facilitiesMarkerRef = useRef<google.maps.Marker[]>([]);
  const markerClustererRef = useRef<MarkerClusterer | null>(null);
  const siteTypesRef = useRef(siteTypes);
  siteTypesRef.current = siteTypes;

  useEffect(() => {
    if (!map) return;

    const isFacilities = siteTypesRef.current.includes("facilities");

    facilitiesMarkerRef.current.forEach((m) => m.setMap(null));
    facilitiesMarkerRef.current = [];
    markerClustererRef.current?.clearMarkers();
    markerClustererRef.current = null;

    if (isFacilities) {
      facilitiesMarkerRef.current = facilities
          .filter(
              (facility) =>
                  !clientID || clientID === "all" || facility.clientID === clientID
          )
          .map((facility) => {
            const [lng, lat] = facility.coordinates;

            const marker = new google.maps.Marker({
              position: {lat, lng},
              clickable: true,
              icon: {
                url: "/assets/mapicons/facility.png",
                size: new google.maps.Size(24, 24),
                scaledSize: new google.maps.Size(24, 24),
                anchor: new google.maps.Point(12, 12),
              },
              optimized: true,
            });

            const facilityStringDiv = renderFacilitiyString(facility);
            const infowindow = renderInfoWindow(facilityStringDiv, facility.name);

            marker.addListener("click", () => {
              infowindow.open({map, anchor: marker});
            });

            marker.setMap(map);
            return marker;
          });
      markerClustererRef.current = new MarkerClusterer({map, markers: facilitiesMarkerRef.current});
    }
  }, [facilities, map, clientID, siteTypes]);

  return;
};

export default useFacilitiesMarker;
